import { type FC } from 'react';
import { OverlayView } from './Overlay/OverlayView.tsx';
import { Spinner } from 'dibs-elements/exports/Spinner.tsx';
import styles from './loadingComponent.module.css';

const LoadingComponent: FC<{ black?: boolean }> = ({ black }) => (
    <OverlayView isTransparent isAboveOverlay isBodyScrollLocked={false}>
        <Spinner black={black} containerClass={styles.centeredDiv} />
    </OverlayView>
);

export { LoadingComponent };
